import React from "react";

import Field from "./index";

export default function Textarea({
  maxLength,
  rows = 3,
  rowsMax = 10,
  ...props
}) {
  const inputProps = {
    maxLength,
  };

  return (
    <Field
      multiline
      inputProps={inputProps}
      rows={rows}
      rowsMax={rowsMax}
      {...props}
    />
  );
}
